document.addEventListener('DOMContentLoaded', function () {
  // Add CSS for variant selected highlight and lightbox
  const style = document.createElement('style');
  style.textContent = `
    .product-slide {
      transition: all 0.3s ease;
      cursor: pointer;
    }
    .product-slide.variant-selected {
      position: relative;
    }
    /* Removed black border styling from variant-selected */
    
    /* Lightbox styles */
    .product-lightbox {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }
    .product-lightbox.active {
      opacity: 1;
      visibility: visible;
    }
    .product-lightbox-image {
      max-width: 90%;
      max-height: 90%;
      object-fit: contain;
    }
    .product-lightbox-close {
      position: absolute;
      top: 20px;
      right: 20px;
      color: white;
      font-size: 30px;
      cursor: pointer;
      background: transparent;
      border: none;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    }
    .product-lightbox-prev,
    .product-lightbox-next {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: white;
      font-size: 30px;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.2);
      border: none;
      width: 40px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      border-radius: 4px;
    }
    .product-lightbox-prev {
      left: 20px;
    }
    .product-lightbox-next {
      right: 20px;
    }
  `;
  document.head.appendChild(style);

  // Initialize Slick slider
  const $slider = document.querySelector('[data-product-slider]');
  if (!$slider) {
    console.warn('Product slider not found. Ensure product has media or snippet is included.');
    return;
  }

  // Create lightbox elements
  const lightbox = document.createElement('div');
  lightbox.className = 'product-lightbox';
  
  const lightboxImage = document.createElement('img');
  lightboxImage.className = 'product-lightbox-image';
  
  const closeButton = document.createElement('button');
  closeButton.className = 'product-lightbox-close';
  closeButton.innerHTML = '×';
  closeButton.setAttribute('aria-label', 'Close lightbox');
  
  const prevButton = document.createElement('button');
  prevButton.className = 'product-lightbox-prev';
  prevButton.innerHTML = '‹';
  prevButton.setAttribute('aria-label', 'Previous image');
  
  const nextButton = document.createElement('button');
  nextButton.className = 'product-lightbox-next';
  nextButton.innerHTML = '›';
  nextButton.setAttribute('aria-label', 'Next image');
  
  lightbox.appendChild(lightboxImage);
  lightbox.appendChild(closeButton);
  lightbox.appendChild(prevButton);
  lightbox.appendChild(nextButton);
  document.body.appendChild(lightbox);
  
  // Current lightbox image index
  let currentLightboxIndex = 0;
  
  // Function to open lightbox
  function openLightbox(index) {
    const slides = document.querySelectorAll('.product-slide img');
    if (slides.length === 0) return;
    
    currentLightboxIndex = index;
    const img = slides[index];
    const fullSizeUrl = img.src.replace(/(\.(jpg|jpeg|png|gif|webp))(_[0-9]+x)?/, '$1');
    
    lightboxImage.src = fullSizeUrl;
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }
  
  // Function to close lightbox
  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  }
  
  // Function to navigate to previous image
  function prevImage() {
    const slides = document.querySelectorAll('.product-slide img');
    if (slides.length === 0) return;
    
    currentLightboxIndex = (currentLightboxIndex - 1 + slides.length) % slides.length;
    const img = slides[currentLightboxIndex];
    const fullSizeUrl = img.src.replace(/(\.(jpg|jpeg|png|gif|webp))(_[0-9]+x)?/, '$1');
    
    lightboxImage.src = fullSizeUrl;
  }
  
  // Function to navigate to next image
  function nextImage() {
    const slides = document.querySelectorAll('.product-slide img');
    if (slides.length === 0) return;
    
    currentLightboxIndex = (currentLightboxIndex + 1) % slides.length;
    const img = slides[currentLightboxIndex];
    const fullSizeUrl = img.src.replace(/(\.(jpg|jpeg|png|gif|webp))(_[0-9]+x)?/, '$1');
    
    lightboxImage.src = fullSizeUrl;
  }
  
  // Add event listeners for lightbox controls
  closeButton.addEventListener('click', closeLightbox);
  prevButton.addEventListener('click', prevImage);
  nextButton.addEventListener('click', nextImage);
  
  // Close lightbox on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowLeft') {
      prevImage();
    } else if (e.key === 'ArrowRight') {
      nextImage();
    }
  });
  
  // Close lightbox when clicking outside the image
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });

  // Debug: Log all variant IDs on images
  console.log('DEBUG: Checking variant IDs on images');
  document.querySelectorAll('.product-slide img').forEach((img, index) => {
    const variantIds = img.dataset.variantIds || '';
    const mediaId = img.dataset.mediaId || '';
    console.log(`Image ${index}: media ID = "${mediaId}", variant IDs = "${variantIds}"`);
    
    // Add click event to open lightbox
    img.addEventListener('click', function() {
      openLightbox(index);
    });
  });

  // Create a mapping of variant IDs to media IDs for quick lookup
  const variantToMediaMap = {};
  
  if (window.productData && window.productData.variants) {
    window.productData.variants.forEach(variant => {
      if (variant.featured_media && variant.featured_media.id) {
        variantToMediaMap[variant.id] = variant.featured_media.id;
      }
    });
  }
  
  console.log('Variant to Media Mapping:', variantToMediaMap);

  try {
    $($slider).slick({
      infinite: false,
      slidesToShow: 3.1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: $('.custom-slick-prev'),
      nextArrow: $('.custom-slick-next'),
      responsive: [
        { breakpoint: 750, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  } catch (error) {
    console.error('Slick initialization failed:', error);
    return;
  }

  // Function to move slider to variant's image
  function moveToVariantSlide(variantId) {
    if (!variantId) return;
    console.log('Moving to variant slide for ID:', variantId);
    let slideIndex = 0;
    let found = false;
    
    // Remove highlight from all slides first
    document.querySelectorAll('.product-slide').forEach(slide => {
      slide.classList.remove('variant-selected');
    });
    
    // First try to find the image using the variant-to-media mapping
    const mediaId = variantToMediaMap[variantId];
    if (mediaId) {
      console.log(`Looking for image with media ID ${mediaId} for variant ${variantId}`);
      const slideImages = document.querySelectorAll('.product-slide img');
      for (let i = 0; i < slideImages.length; i++) {
        const img = slideImages[i];
        const imgMediaId = img.getAttribute('data-media-id');
        if (imgMediaId && imgMediaId == mediaId) {
          slideIndex = i;
          found = true;
          console.log(`Found image with media ID ${mediaId} at index ${i}`);
          
          // Add highlight class to the slide
          const slide = img.closest('.product-slide');
          if (slide) slide.classList.add('variant-selected');
          break;
        }
      }
    }
    
    // If not found by media ID, try the variant IDs
    if (!found) {
      console.log('DEBUG: Searching for image with variant ID:', variantId);
      
      // Use native DOM instead of jQuery to avoid data attribute issues
      const slideImages = document.querySelectorAll('.product-slide img');
      for (let i = 0; i < slideImages.length; i++) {
        const img = slideImages[i];
        const variantIdsStr = img.getAttribute('data-variant-ids') || '';
        console.log(`Checking image ${i}, variant IDs: "${variantIdsStr}"`);
        
        if (variantIdsStr && variantIdsStr.length > 0) {
          const idsArray = variantIdsStr.split(',');
          console.log(`Split into array:`, idsArray);
          
          if (idsArray.includes(variantId.toString())) {
            slideIndex = i;
            found = true;
            console.log(`Found variant ${variantId} image at index:`, i);
            
            // Add highlight class to the slide
            const slide = img.closest('.product-slide');
            if (slide) slide.classList.add('variant-selected');
            break;
          }
        }
      }
    }
    
    // If still not found, use the first slide
    if (!found) {
      console.warn(`No image found for variant ID ${variantId}, using first slide`);
      slideIndex = 0;
      
      // Highlight the first slide as fallback
      const firstSlide = document.querySelector('.product-slide');
      if (firstSlide) {
        firstSlide.classList.add('variant-selected');
      }
    }
    
    try {
      console.log(`Moving slick to slide ${slideIndex}`);
      
      // Move the selected variant's slide to the first position instead of just navigating to it
      if (found && slideIndex > 0) {
        console.log(`Moving variant slide from position ${slideIndex} to first position`);
        
        // Get the slick instance
        const slickInstance = $($slider).slick('getSlick');
        
        // Unslick temporarily to manipulate the DOM
        $($slider).slick('unslick');
        
        // Get the slide element to move
        const slideToMove = document.querySelectorAll('.product-slide')[slideIndex];
        const sliderContainer = slideToMove.parentElement;
        
        // Move the slide to the first position
        sliderContainer.insertBefore(slideToMove, sliderContainer.firstChild);
        
        // Re-initialize slick
        $($slider).slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          prevArrow: $('.custom-slick-prev'),
          nextArrow: $('.custom-slick-next'),
          responsive: [
            { breakpoint: 750, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
          ]
        });
        
        // Go to the first slide (which is now our variant slide)
        $($slider).slick('slickGoTo', 0);
      } else {
        // If not moving slides around, just navigate to the slide
        $($slider).slick('slickGoTo', slideIndex);
      }
    } catch (error) {
      console.error('Failed to move or reorder slides:', error);
    }
  }

  // Move to initial variant's slide
  const initialVariantId = window.productData?.currentVariantId;
  if (initialVariantId) {
    console.log('Initial variant ID:', initialVariantId);
    moveToVariantSlide(initialVariantId);
  }

  // Skip variant handling if no variants or single variant
  if (!window.productData?.variants || window.productData.variants.length <= 1) {
    console.log('No variants or single variant product, skipping variant listener.');
    return;
  }

  // Debug: Log all variants from productData
  console.log('DEBUG: Available variants:');
  if (window.productData?.variants) {
    window.productData.variants.forEach(variant => {
      console.log(`Variant ID: ${variant.id}, Title: ${variant.title}, Media ID: ${variant.featured_media?.id || 'none'}`);
    });
  }

  // Multiple approaches to detect variant changes
  function setupVariantChangeListeners() {
    // 1. Listen for variant-selects change events
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      console.log('Found variant-selects element, setting up change listener');
      variantSelects.addEventListener('change', handleVariantChange);
    }

    // 2. Listen for variant radio button changes
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      console.log('Found variant-radios element, setting up change listener');
      variantRadios.addEventListener('change', handleVariantChange);
    }

    // 3. Listen for changes on any input with name starting with "Color-", "Size-", etc.
    document.querySelectorAll('input[type="radio"][name^="Color-"], input[type="radio"][name^="Size-"]').forEach(input => {
      input.addEventListener('change', handleVariantChange);
    });

    // 4. Listen for URL changes that might indicate variant changes
    window.addEventListener('popstate', function() {
      setTimeout(checkUrlForVariantChange, 100);
    });

    // 5. Listen for form changes on the product form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        // Use MutationObserver to watch for value changes
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              const newVariantId = variantInput.value;
              console.log('Product form variant ID changed to:', newVariantId);
              moveToVariantSlide(newVariantId);
            }
          });
        });
        
        observer.observe(variantInput, { attributes: true });
        console.log('Set up observer for variant input in form');
      }
    }

    // Initial check for URL variant
    checkUrlForVariantChange();
    
    // 6. Listen for clicks on variant swatches or option selectors
    document.querySelectorAll('.swatch-element, .color-swatch, .single-option-selector').forEach(element => {
      element.addEventListener('click', function(e) {
        // Give the form time to update
        setTimeout(checkFormForVariantChange, 100);
      });
    });
  }

  function checkFormForVariantChange() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = variantInput.value;
        console.log('Detected variant change from form:', variantId);
        moveToVariantSlide(variantId);
      }
    }
  }

  function handleVariantChange(event) {
    console.log('Variant change detected:', event.type);
    
    // Try to find the selected variant ID
    let selectedVariantId = null;
    
    // Method 1: Check if there's a URL parameter for variant
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) {
      selectedVariantId = variantParam;
      console.log('Found variant ID from URL:', selectedVariantId);
    }
    
    // Method 2: Check for selected radio button
    if (!selectedVariantId) {
      const selectedInput = document.querySelector('input[type="radio"][name^="Color-"]:checked, input[type="radio"][name^="Size-"]:checked');
      if (selectedInput) {
        const selectedValue = selectedInput.value;
        console.log('Found selected option value:', selectedValue);
        
        // Find the variant with this option
        const selectedVariant = window.productData?.variants?.find(variant => 
          variant.options.includes(selectedValue) || variant.option1 === selectedValue
        );
        
        if (selectedVariant) {
          selectedVariantId = selectedVariant.id;
          console.log('Found matching variant ID:', selectedVariantId);
        }
      }
    }
    
    // Method 3: Check for data attribute on form
    if (!selectedVariantId) {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          selectedVariantId = variantInput.value;
          console.log('Found variant ID from form:', selectedVariantId);
        }
      }
    }
    
    // Method 4: If event target is a select or radio, try to get the variant directly
    if (!selectedVariantId && event.target) {
      if (event.target.tagName === 'SELECT') {
        // For select elements
        const selectOptions = Array.from(event.target.options);
        const selectedOption = selectOptions.find(option => option.selected);
        if (selectedOption && selectedOption.dataset.variantId) {
          selectedVariantId = selectedOption.dataset.variantId;
          console.log('Found variant ID from select option:', selectedVariantId);
        }
      } else if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
        // For radio inputs
        if (event.target.dataset.variantId) {
          selectedVariantId = event.target.dataset.variantId;
          console.log('Found variant ID from radio input:', selectedVariantId);
        }
      }
    }
    
    // If we found a variant ID, move to its slide
    if (selectedVariantId) {
      moveToVariantSlide(selectedVariantId);
    } else {
      console.warn('Could not determine selected variant ID');
    }
  }

  function checkUrlForVariantChange() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    
    if (variantParam) {
      console.log('Detected variant from URL:', variantParam);
      moveToVariantSlide(variantParam);
    }
  }

  // Set up all variant change listeners
  setupVariantChangeListeners();

  // Update slider for pre-selected variant (e.g., from URL or JSON)
  const selectedVariantJson = document.querySelector('[data-selected-variant]');
  if (selectedVariantJson) {
    try {
      const selectedVariantData = JSON.parse(selectedVariantJson.textContent);
      if (selectedVariantData?.id) {
        console.log('Pre-selected Variant:', {
          id: selectedVariantData.id,
          title: selectedVariantData.title,
          price: selectedVariantData.price,
          available: selectedVariantData.available,
          options: selectedVariantData.options,
          image_id: selectedVariantData.featured_image?.id || 'N/A'
        });
        moveToVariantSlide(selectedVariantData.id);
      }
    } catch (error) {
      console.error('Failed to parse selected variant JSON:', error);
    }
  }

  // Also listen for custom events that might be triggered by the theme
  document.addEventListener('variant:changed', function(event) {
    console.log('Caught variant:changed event', event.detail);
    if (event.detail && event.detail.variant && event.detail.variant.id) {
      moveToVariantSlide(event.detail.variant.id);
    }
  });
  
  // Direct DOM monitoring for variant selection changes
  // This is a fallback approach that should catch any variant changes
  setInterval(function() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        const currentVariantId = variantInput.value;
        
        // Store the last known variant ID in a data attribute on the body
        if (!document.body.dataset.lastVariantId || document.body.dataset.lastVariantId !== currentVariantId) {
          console.log('Detected variant change via polling:', currentVariantId);
          document.body.dataset.lastVariantId = currentVariantId;
          moveToVariantSlide(currentVariantId);
        }
      }
    }
  }, 500); // Check every 500ms
  
  // Add a debug button to show the variant-media debug table
  // const debugButton = document.createElement('button');
  // debugButton.textContent = 'Toggle Debug Info';
  // debugButton.style.cssText = 'position: fixed; bottom: 10px; right: 10px; z-index: 9999; background: #f1f1f1; border: 1px solid #ddd; padding: 5px 10px; cursor: pointer;';
  // debugButton.addEventListener('click', function() {
  //   const debugTable = document.querySelector('.variant-media-debug');
  //   if (debugTable) {
  //     debugTable.style.display = debugTable.style.display === 'none' ? 'block' : 'none';
  //   }
  // });
  // document.body.appendChild(debugButton);
});